import {
  ERROR_LOADING_TAGS,
  GET_ALL_TAGS,
  RESET_DATA,
  START_LOADING_TAGS,
  STOP_LOADING_TAGS,
} from "./action-types";
import initialState, { ITag } from "./initialState";

export const tagsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case START_LOADING_TAGS:
      return {
        ...state,
        stateIs: "Pending",
      };

    case ERROR_LOADING_TAGS:
      return {
        ...state,
        stateIs: "Error",
      };

    case STOP_LOADING_TAGS:
      return {
        ...state,
        stateIs: "Idle",
      };
    case GET_ALL_TAGS:
      const tags = action.payload.tags.map((item: ITag) => {
        const { description, id, tagName, taggedEntities } = item;
        const data = {
          description,
          id,
          tagName,
          taggedEntities,
        };
        return data;
      });

      return {
        ...state,
        data: {
          tags: tags,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
        },
        message: "",
        stateIs: "Idle",
      };
    case RESET_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};
